import BondContractsContext from "./context";
import {useContext} from "react";

export default function useBondContracts(): any {
	return useContext(BondContractsContext);
}
